import React from "react";
import PropTypes from "prop-types";
import { CopyToClipboard } from "react-copy-to-clipboard";
//Material imports
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import withStyles from "@mui/styles/withStyles";
//Limitless imports
import { withi18n } from "../../../../customer/components/hocs/i18n";
const HeaderIconButton = ({
  classes,
  t,
  icon,
  onButtonClick,
  buttonId,
  ariaLabel,
  disabled,
  buttonClass,
  buttonStyle,
  color,
  tooltip,
  copyValue,
  copyToClipboardFeature,
  iconButtonRef
}) => {
  const [open, setOpen] = React.useState(false);
  const handleOnClick = event => {
    event.stopPropagation();
    handleTooltipClose();
    if (typeof onButtonClick === "function") {
      onButtonClick();
    }
  };
  const handleTooltipClose = () => {
    setOpen(false);
  };
  const handleTooltipOpen = () => {
    setOpen(true);
  };
  const {
    primary,
    secondary,
    primaryContrast,
    grey,
    ...otherClasses
  } = classes;
  const colorClasses = {
    primary,
    secondary,
    primaryContrast,
    grey
  };
  const renderIconButton = () => {
    return /*#__PURE__*/React.createElement(IconButton, {
      "aria-label": ariaLabel ? ariaLabel : tooltip,
      id: buttonId,
      onClick: handleOnClick,
      disabled: disabled,
      style: buttonStyle,
      className: `${colorClasses[color]} ${buttonClass}`,
      ref: iconButtonRef ? iconButtonRef : null,
      size: "large"
    }, icon);
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Tooltip, {
    open: open,
    onClose: handleTooltipClose,
    onOpen: handleTooltipOpen,
    disableFocusListener: true,
    title: t(tooltip),
    classes: otherClasses,
    placement: "bottom",
    arrow: true
  }, /*#__PURE__*/React.createElement("div", null, copyToClipboardFeature && /*#__PURE__*/React.createElement(CopyToClipboard, {
    text: copyValue
  }, renderIconButton()), !copyToClipboardFeature && renderIconButton())));
};
const styles = theme => {
  var _theme$palette$contra;
  return {
    tooltip: {
      position: "relative",
      fontWeight: 500
    },
    popper: {
      "&[data-popper-placement*='bottom'] .arrow": {
        top: 0,
        left: 0,
        marginTop: "-0.95em",
        width: "2em",
        height: "1em",
        "&::before": {
          borderWidth: "0 1em 1em 1em",
          borderColor: `transparent transparent ${theme.palette.grey[600]} transparent`
        }
      },
      "&[data-popper-placement*='top'] .arrow": {
        bottom: 0,
        left: 0,
        marginBottom: "-0.95em",
        width: "2em",
        height: "1em",
        "&::before": {
          borderWidth: "1em 1em 0 1em",
          borderColor: `${theme.palette.grey[600]} transparent transparent transparent`
        }
      },
      "&[data-popper-placement*='right'] .arrow": {
        left: 0,
        marginLeft: "-0.95em",
        height: "2em",
        width: "1em",
        "&::before": {
          borderWidth: "1em 1em 1em 0",
          borderColor: `transparent ${theme.palette.grey[600]} transparent transparent`
        }
      },
      "&[data-popper-placement*='left'] .arrow": {
        right: 0,
        marginRight: "  ",
        height: "2em",
        width: "1em",
        "&::before": {
          borderWidth: "1em 0 1em 1em",
          borderColor: `transparent transparent transparent ${theme.palette.grey[600]}`
        }
      }
    },
    tooltipPlacementBottom: {
      margin: "8px 0 !important"
    },
    primary: {
      color: theme.palette.primary.main,
      backgroundColor: "transparent",
      "&:disabled": {
        color: theme.palette.mode === "light" ? theme.palette.grey[2] : theme.palette.grey[1],
        cursor: "not-allowed",
        opacity: 0.6
      },
      "&:hover": {
        color: "rgba(0, 0, 0, 0.54)",
        backgroundColor: "transparent"
      }
    },
    secondary: {
      color: theme.palette.secondary.main
    },
    primaryContrast: {
      color: theme.palette.primary.contrastText,
      "&:disabled": {
        color: (_theme$palette$contra = theme.palette.contrast) === null || _theme$palette$contra === void 0 ? void 0 : _theme$palette$contra.text
      }
    },
    grey: {
      "&:hover": {
        color: theme.palette.secondary.main
      }
    }
  };
};
export default withStyles(styles)(withi18n(HeaderIconButton));
HeaderIconButton.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  icon: PropTypes.node,
  onButtonClick: PropTypes.func,
  buttonId: PropTypes.string.isRequired,
  tooltip: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string,
  disabled: PropTypes.bool,
  buttonClass: PropTypes.string,
  buttonStyle: PropTypes.object,
  copyToClipboardFeature: PropTypes.bool,
  copyValue: PropTypes.string,
  color: PropTypes.string,
  iconButtonRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
};
HeaderIconButton.defaultProps = {
  disabled: false,
  buttonClass: "",
  buttonStyle: {},
  copyToClipboardFeature: false,
  copyValue: "",
  color: "grey"
};